import headerParallax from './_headerParallax';
import tripAccordionInit from './_trip-accordion';
import tripPriceTabs from './_tripPriceTabs';
import radiosAccordionInit from './_radiosAccordion';
import initEnquiryForm from './_enquiryForm'
import initModalTriggers from './jsModal';
import initExtraTravelers from './_extraTravelers';
import { initSliderImageTitles } from './_sliderImageTitles';
import { initCountingNumbers } from './_countingNumbers';
import initInpageNavVisibility from './_inpageNavVisibility';
import closeMainNavOnOutsideClick from './_closeMainMenuOnOutsideClick';
import mainNavToggleOpenMenuItem from './_mainNavToggleOpenMenuItem';
import { initTopbarSearch } from "./topbar-search";
import { initSolrResultsSlider } from "./_solrResultsSlider";
import { initSearchBar } from "./search-bar";
import { initConversionSearch } from "./_conversionSearch";
import { initNProductTeaserSlider } from "./_nProductTeaserSlider";

document.addEventListener('DOMContentLoaded', () => {
  headerParallax();
  closeMainNavOnOutsideClick();
  mainNavToggleOpenMenuItem();
  initConversionSearch();
  initNProductTeaserSlider();

  if (document.querySelector('.trip-accordion')) {
    tripAccordionInit();
  }

  if (document.querySelector('section[hasTripTabs]')) {
    tripPriceTabs();
  }

  if (document.querySelector('.radio-accordion')) {
    radiosAccordionInit();
  }

  if (document.querySelector('.enquiry__form')) {
    initEnquiryForm();
  }

  if (document.querySelector('.js-modal-trigger')) {
    initModalTriggers();
  }

  if (document.querySelector('#travelersExtraFormsContainer')) {
    initExtraTravelers();
  }

  if (document.querySelector('.section--numbers-list')) {
    initCountingNumbers();
  }

  if (document.querySelector('.inpage-nav__marker--top')) {
    initInpageNavVisibility();
  }

  if (document.querySelector('.topbar-search')) {
    initTopbarSearch();
  }

  if (document.querySelector('.results-slider')) {
    initSolrResultsSlider();
  }

  if (document.querySelector('.search-bar')) {
    initSearchBar();
  }
});

window.addEventListener('glider-loaded', (event) => {
  initSliderImageTitles(event.target)
})
